import { merge } from "lodash-es";
import Vue from "vue";
import VueI18n from "vue-i18n";
import { getLocale, loadLocaleMessages } from "@/lib/localeHelper";
import config from "@/config";

Vue.use(VueI18n);

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  silentTranslationWarn: true,
  formatFallbackMessages: true,
  messages: merge(loadLocaleMessages(), config.localeOverrides),
});
